WiseMetering.Collection.GlobalReportTypes = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.GlobalReportType,
    url: '/report_types/global_report_types',

    grouped: function() {
        return _.groupBy(this.toJSON(), function(model) {
            return model.category;
        });
    },

    filterTypes: function() {
        const isSouthOpe = WiseMetering.currentOrganization.get('subdomain') === 'southope',
            types = isSouthOpe ? this : this.standardGlobalReportSuite();

        types.each(report => {
            let active = true;
            // The Global* slugs were renamed to Organization* in #575
            // ("Refactor reports") but this gate still referenced the
            // old names, so the plan permission was never enforced for
            // the renamed types. Aligning the check with the new slugs.
            if (['OrganizationDetailedReport', 'OrganizationOptimiserReport'].includes(report.get('type'))) {
                active = WiseMetering.Permissions.hasPlanPermissions('standardReports');
            }
            report.set({ active });
        });

        return types.grouped();
    },

    standardGlobalReportSuite: function() {
        // Same Global* → Organization* rename applies here; the southope
        // carve-out above relies on this filter to drop the Invoice
        // type from every other org.
        let reports = this.filter((report) => report.get('type') !== 'OrganizationInvoiceReport');
        return new WiseMetering.Collection.GlobalReportTypes(reports);
    }
});
